import { combineReducers } from 'redux';

import UserReducer from './UserReducer';
import GroupReducer from './GroupReducer';
import SessionReducer from './SessionReducer';
import InfluencersReducer from './InfluencersReducer';
import premiumReducer from './premiumReducer';
import ReportReducer from './ReportReducer';
import AgentReducer from './AgentReducer';

export const reducer = combineReducers({
  user: UserReducer,
  group: GroupReducer,
  session: SessionReducer,
  premium: premiumReducer,
  influencers: InfluencersReducer,
  report: ReportReducer,
  agent:AgentReducer
})
